<template lang="pug" xmlns="">
v-list.ma-0
  div.item--no-active(v-if="items.length === 0")
    slot(name='no-data')
      span {{$t('common.no_data')}}
  v-list-item-group(:value="cursor" color="primary")
    v-list-item.px-2(v-for="(item, index) in items"
      :key="index"
      @click="onChange(index)"
      @keydown="onChange(index)" dense
      :disabled="itemDisabled(item)"
      :class="index===cursor ? 'item--auto-select' : 'item--no-active'")
      slot(name="item" :item="item")
        span {{ item.code }}: {{ item.name }}
    slot(name="new_master" :items="items")
    slot(name="infinite-scroll-trigger")
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    cursor: { default: null },
    items: { default: () => [] },
    returnValue: { default: null },
    returnObject: { default: false },
    returnCodeName: { default: false },
    itemDisabled: { type: Function, default: (item) => false }
  },
  setup(props, { emit }) {
    const onChange = (changedIndex) => {
      if (changedIndex === undefined || changedIndex === null) return
      const selectedItem = props.items[changedIndex]
      const isItemDisabled = props.itemDisabled(selectedItem)
      if (isItemDisabled) return
      // By default, it will emit 'change' event with value {selectedItem.code}: {selectedItem.name}
      let value = `${selectedItem.code}: ${selectedItem.name}`
      if (selectedItem.branch_code)
        value = `${selectedItem.code}-${selectedItem.branch_code}: ${selectedItem.name}`

      // In case returnValue = {prop_name}, it will emit 'change' event with value {selectedItem[prop_name]}
      if (props.returnValue !== null)
        value = Object.keys(selectedItem).includes(props.returnValue)
          ? selectedItem[props.returnValue]
          : null
      // Or emit 'change' event with whole of selected object
      else if (props.returnObject) value = selectedItem
      // get selected item
      emit('on-select', selectedItem)
      emit('change', value)
    }

    return {
      onChange
    }
  }
})
</script>

<style scoped lang="sass">
.content
  z-index: 10 !important
  position: relative
  border: #1dc125 1px
::v-deep .v-list-item.item--no-active
  background-color: white !important
::v-deep .v-list-item.item--auto-select
  background-color: #e0efe7
</style>
